import { render, staticRenderFns } from "./account.settings.vue?vue&type=template&id=991d1da0&scoped=true&"
import script from "./account.settings.vue?vue&type=script&lang=js&"
export * from "./account.settings.vue?vue&type=script&lang=js&"
import style0 from "./account.settings.vue?vue&type=style&index=0&id=991d1da0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "991d1da0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VContainer,VForm,VTextField})
